import { render, staticRenderFns } from "./PurchaseOrderDetailsModal.vue?vue&type=template&id=02e78674&scoped=true"
import script from "./PurchaseOrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetailsModal.vue?vue&type=style&index=0&id=02e78674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e78674",
  null
  
)

export default component.exports